import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Form from './form'

export default function PopupForm(props) {
    const [modalShow, setModalShow] = React.useState(false);
    return (
        <div className="ClientDetails">
            <Button style={{borderRadius:'25px'}} onClick={() => setModalShow(true)}>
                Confused in choosing category ?
            </Button>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <h4 onClick={()=>setModalShow(false)} style={{ right:0,margin:'20px', position:'absolute',color:'tomato',cursor:'pointer' }}>x</h4>
                <Form category="Others" user={props.user}/>
            </Modal>
        </div>
    );
}
